import { render, staticRenderFns } from "./CongestionSegmentsChart.vue?vue&type=template&id=2451c32e&scoped=true&"
import script from "./CongestionSegmentsChart.vue?vue&type=script&lang=js&"
export * from "./CongestionSegmentsChart.vue?vue&type=script&lang=js&"
import style0 from "./CongestionSegmentsChart.vue?vue&type=style&index=0&id=2451c32e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2451c32e",
  null
  
)

export default component.exports